<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      ВСН 012-88 (Часть 2)
    </div>
    <div class="chapter-title">ЖУРНАЛ <br> поэтапной приемки подводного перехода под укладку</div>
    <n-items v-if="project">
      <n-input title="Министерство" v-bind="$form.input('p1.1')" :text="!editable" />
      <n-input title="Форма №" v-bind="$form.input('p1.2')" :text="!editable" />
      <n-input title="Объединение, трест " v-bind="$form.input('p1.3')" :text="!editable" />
      <n-input title="Основание:" v-bind="$form.input('p1.4')" :text="!editable" />
      <n-input title="СУПТР" v-bind="$form.input('p1.5')" :text="!editable" />
      <n-input title="Строительство" v-bind="$form.input('p1.6')" :text="!editable" />
      <n-input title="Участок" v-bind="$form.input('p1.7')" :text="!editable" />
      <n-input title="Объект " v-bind="$form.input('p1.8')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
